/* Ott-common */
import { assetTypes } from '@dtvgo/rtk-query-api';

/* Other */
import { formatSeasonAndEpisode, joinArrayWithSeparator } from './metadata';

/**
 * @method buildPlayerAssetMetadata
 * @description Build the asset metadata based on content to be displayed in the player
 * @param {object} content Asset data
 * @param {function} formatMessage i18n translate function
 */
export const buildPlayerAssetMetadata = (asset, formatMessage) => {
  const {
    episode,
    genres,
    title,
    type,
    vod,
  } = asset || {};

  const { number: episodeNumber, seasonNumber } = episode || {};
  const { releaseYear } = vod || {};
  const genreName = genres?.[0];

  switch (type) {
    case assetTypes.movie:
    case assetTypes.liveMovie:
      return joinArrayWithSeparator([genreName, releaseYear]);
    case assetTypes.episode:
    case assetTypes.liveEpisode:
      return joinArrayWithSeparator([
        formatSeasonAndEpisode(
          seasonNumber,
          episodeNumber,
          formatMessage,
        ),
        title,
      ]);
    case assetTypes.show:
    case assetTypes.liveShow:
    case assetTypes.sport:
    case assetTypes.liveSport:
      return genreName;
    default:
      return '';
  }
};

export const toSnakeCase = (str) => {
  try {
    return str
      ?.toLowerCase()
      ?.trim()
      ?.replace(/\s+/g, '_')
      ?.replace(/_+/g, '_');
  } catch (error) {
    console.error(`An error occurred while converting to snake case: ${error.message}`);
    return str;
  }
};

export const getValueAfterHyphen = (input) => {
  if (typeof input !== 'string') return input;

  const parts = input?.split('-');

  return parts?.length > 1 && parts[1] ? parts[1] : input;
};

export const getQueryParameters = (url) => {
  if (!url || typeof url !== 'string') return url;

  const queryString = url?.includes('?') ? url?.split('?')[1] : url;

  if (!queryString) return {};

  const searchParams = new URLSearchParams(queryString);
  const params = {};

  for (const [key, value] of searchParams.entries()) {
    params[key] = value;
  }

  return params;
};

/**
 * @method buildPlayerAssetMetadata
 * @description Build the asset metadata based on content to be displayed in the player UI V2
 * @param {object} content Asset data
 * @param {function} formatMessage i18n translate function
 */
export const buildPlayerAssetMetadataV2 = (asset) => {
  const {
    genres,
  } = asset || {};

  return genres.join(' • ');
};
